import { render, staticRenderFns } from "./ShippingMethods.vue?vue&type=template&id=6dd2ac48&scoped=true"
import script from "./ShippingMethods.vue?vue&type=script&lang=js"
export * from "./ShippingMethods.vue?vue&type=script&lang=js"
import style0 from "./ShippingMethods.vue?vue&type=style&index=0&id=6dd2ac48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd2ac48",
  null
  
)

export default component.exports